<div class="backpage-wrapper">
  <div class="nfc-cred-content-creator">
    <div class="nfc-mobile-section">
      <div
        class="nfc-cred-container padding s6 all"
        *ifPermissions="['Mobile Cred Support', 'Internal Admin']"
      >
        <div class="header">
          <h1>NFC Mobile Credentials</h1>
        </div>
        <div class="search padding s8 all">
          <div
            class="inventory-main-title mat-title"
            *ifPermissions="['Mobile Cred Support', 'Internal Admin']"
          >
            {{ "Search.SelectCompany" | translate }}:
          </div>

          <!-- Account search form -->
          <form class="example-form" [formGroup]="form3">
            <mat-form-field
              class="example-full-width"
              appearance="outline"
              floatLabel="always"
            >
              <mat-label class="selectCo">{{
                "Search.Company" | translate
              }}</mat-label>
              <input
                type="text"
                placeholder="{{ 'Search.Placeholder' | translate }}"
                matInput
                formControlName="myControl"
                [matAutocomplete]="auto"
                [errorStateMatcher]="errorStateMatcher"
              />
              <mat-autocomplete
                autoActiveFirstOption
                #auto="matAutocomplete"
                mat-autoselect="true"
                [displayWith]="displayNameMobileCreds.bind(this)"
                (optionSelected)="loadMobileCredSummaryTechSupport($event)"
              >
                <mat-option
                  *ngFor="let option of filteredOptions | async"
                  [value]="option"
                >
                  {{ option.businessId }} (Account #{{
                    option.accountNumber || "N/A"
                  }}) <br />
                  {{ option.addressCity }}, {{ option.addressState }}
                </mat-option>
              </mat-autocomplete>
              <mat-error
                *ngIf="
                  (form3.controls['myControl'].dirty ||
                    form3.controls['myControl'].touched) &&
                  noResultsFound
                "
                >No results - Try again</mat-error
              >
            </mat-form-field>
          </form>
        </div>
      </div>

      <div
        class="nfc-cred-container padding s6 all"
        *ifPermissions="['Mobile Cred View']"
      >
        <div class="header">
          <h1>NFC Mobile Credentials</h1>
        </div>
        <div class="inputs">
          <app-branch-inputs
            *ifPermissions="[
              'Engage View',
              'Engage Transfer',
              'API View',
              'Mobile Cred View',
              'Internal Admin'
            ]"
          ></app-branch-inputs>
        </div>
      </div>
      <div class="nfc-cred-container padding s6 all">
        <div class="header">
          <h1>License Tracker</h1>
        </div>
        <app-license-tracker
          [totalCpLicenses]="licenseTrackerData.totalCpLicenses || 0"
          [totalCpCmLicenses]="licenseTrackerData.totalCpCmLicenses || 0"
          [companyName]="companyName || ''"
        ></app-license-tracker>
      </div>
    </div>

    <div class="nfc-cred-container padding s6 all">
      <div class="header">
        <h1>Implementation Details</h1>
      </div>
      <div class="mobileCred-main MC-landing-table-section">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z24">
          <!-- Integration Name Column -->
          <ng-container matColumnDef="implementationName">
            <th mat-header-cell *matHeaderCellDef>Implementation Name</th>
            <td mat-cell *matCellDef="let element">
              {{ element.implementationName }}
            </td>
          </ng-container>

          <!-- Total Billable Licenses Column -->
          <ng-container matColumnDef="totalBillableLicenses">
            <th mat-header-cell *matHeaderCellDef>Total Billable Licenses</th>
            <td mat-cell *matCellDef="let element">
              {{ element.totalBillableLicenses }}
            </td>
          </ng-container>

          <!-- Solution Type Column -->
          <ng-container matColumnDef="solutionType">
            <th mat-header-cell *matHeaderCellDef>Solution Type</th>
            <td mat-cell *matCellDef="let element">
              {{ element.solutionType }}
            </td>
          </ng-container>

          <!-- LicenseType -->
          <ng-container matColumnDef="vertical">
            <th mat-header-cell *matHeaderCellDef>License Type</th>
            <td mat-cell *matCellDef="let element">
              {{ element.vertical }}
            </td></ng-container
          >

          <!-- Billing Anniversary Date Column -->
          <ng-container matColumnDef="anniversaryDate">
            <th mat-header-cell *matHeaderCellDef>Billing Anniversary Date</th>
            <td mat-cell *matCellDef="let element">
              {{ datePipe.transform(element.anniversaryDate, "MM/dd/yyyy") }}
            </td>
          </ng-container>

          <!-- More Details Column -->
          <ng-container matColumnDef="moreDetails">
            <th mat-header-cell *matHeaderCellDef>More Details</th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button (click)="openDetailsDialog(element)">
                <mat-icon class="flip-horizontal">more</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr
            mat-header-row
            class="custom-header-row"
            *matHeaderRowDef="displayedColumns"
          ></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator
          [pageSizeOptions]="[5, 10, 20]"
          showFirstLastButtons
          #paginator
          class="paginator"
        ></mat-paginator>
      </div>
    </div>
  </div>
</div>
